import {ToasterComponent} from '../../../toasterComponent/toasterComponent';
import {Component, ViewContainerRef} from '@angular/core';
import {MDMService} from '../services/mdmService.service';
import {BiUrls} from '../../biUrls';

@Component({
    selector: 'tenantConfiguration',
    templateUrl: 'tenantConfiguration.component.html',
})

export class tenantConfigComponent {

    public resetDefaultsUrl: any = 'reset';
    public tntConfData: any = {
        tenantConfigDataList: [],
        customScaleList: [],
        measureStatusIndicatorData: [],
        measureColorData: []
    };
    public weekDayList: any = [
        'Monday', 'Tuesday', 'Wednesday',
        'Thursday', 'Friday', 'Saturday', 'Sunday'];
    public loader: boolean = false;
    public mainPage: boolean = true;
    public isEdit: boolean = false;
    public accessDenied = false;
    public xErrorMsg: string = '';
    public xErrorMsg1: string = '';
    public tenantConfigList: any = [];
    public customScaleList: any = [];
    public measureColorData: any = [];
    public colorPaletevalue: any = [];
    public dashboardExpiry: any;

    constructor(
        public tenantConfigService: MDMService,
        public toastr: ToasterComponent,
        public vcr: ViewContainerRef) {
        this.toastr.setViewRef(vcr);
    }

    ngOnInit() {
        if (this.tenantConfigService.isBIAdmin) {
            this.loadTenantConfigs();
        } else {
            this.accessDenied = true;
        }
    }

    loadTenantConfigs() {
        let self = this;
        self.loader = true;
        return new Promise((resolve) => {
            self.tenantConfigService.onStartUp(BiUrls.TENANT_CONFIG).then((res) => {
                if (res == undefined) {
                    self.toastr.showError('No Tenant Configurations to load');
                }
                self.tntConfData = res;
                self.setConfigList();
                self.loader = false;
                self.mainPage = true;
                resolve('completed');
            }, (error) => {
                if (error.status == 204) {
                    self.toastr.showError('Cannot load the tenant configurations');
                }
            });
        });
    }

    editTenantConfig(event) {
        let self = this;
        self.mainPage = false;
        self.isEdit = true;
    }

    setConfigList() {
        this.customScaleList = [];
        this.tenantConfigList = [];
        this.measureColorData = [];
        let data = this.tntConfData.tenantConfigDataList;
        data.forEach(val => {
            if (val.type && val.type == 'SCALE') {
                if (typeof val.value == 'string') {
                    val.value = JSON.parse(val.value)
                }
                this.customScaleList.push(val);
            } else if (val.key == "COLOR_PALETTE") {
                val.value = JSON.parse(val.value);
                this.colorPaletevalue = [];
                val.value.forEach(value1 => {
                    this.colorPaletevalue.push(value1);
                });
                this.measureColorData.push(this.colorPaletevalue);
            } else if (val.key == "PAGE_SNAPSHOT_EXPIRY") {
                this.dashboardExpiry = val;
            } else {
                this.tenantConfigList.push(val);
            }
        });
        this.customScaleList.sort((a, b) => {
            return +a.value.value - +b.value.value;
        });
    }

    getConfigType(config) {
        if (config.key == "WEEK_START_DAY") {
            return 1;
        } else if (config.key == "MONTH_START_DATE") {
            return 2;
        } else if (config.key == "YEAR_START_MONTH") {
            return 5;
        } else if (config.key == "FONT_SIZE") {
            return 6;
        } else if (config.key == "NEGATIVE"
            || config.key == "NEUTRAL"
            || config.key == "POSITIVE") {
            return 4;
        } else {
            return 3;
        }
    }

    addIndicators() {
        let self = this;
        let msrIndData = { name: '', value: null, code: '' };
        self.tntConfData.measureStatusIndicatorData.push(msrIndData);
    }
    addColorPalette() {
        let self = this;
        let value1 = {startcolor: '', endcolor: ''};
        this.colorPaletevalue.push(value1);
    }

    addColorPaletteToConfig() {
        // let self = this;
        this.measureColorData = {};
        let value = JSON.stringify(this.colorPaletevalue);
        this.measureColorData['key'] = "COLOR_PALETTE";
        this.measureColorData['displayName'] = "Color Palette";
        this.measureColorData['value'] = value;
    }

    addScales() {
        let self = this;
        let value = {code: "", value: "", type: "SCALE"};
        let scaleData = { displayName: '', key: '', type: 'SCALE', value: value, valueData: null, new: true };
        self.customScaleList.push(scaleData);
    }

    onIndicatorDelete(configIndex) {
        let self = this;
        self.tntConfData.measureStatusIndicatorData.splice(configIndex, 1);
    }
    onColorPaletteDelete(configIndex) {
        this.colorPaletevalue.splice(configIndex, 1);
    }

    onScaleDelete(configIndex) {
        this.customScaleList.splice(configIndex, 1);
    }

    onSave() {
        let self = this;
        self.loader = true;
        let validatedRes = self.validator();
        if (validatedRes != '') {
            self.toastr.showError(validatedRes);
            self.loader = false;
            self.isEdit = true;
        } else {
            self.setScaleKey();
            self.addColorPaletteToConfig();
            self.addPageConfig();
            self.tntConfData.tenantConfigDataList = self.tenantConfigList;
            self.tntConfData.tenantConfigDataList.push(self.measureColorData);
            self.tntConfData.tenantConfigDataList.push(...self.customScaleList);
            self.tenantConfigService.save(BiUrls.TENANT_CONFIG, self.tntConfData).then((res) => {
                if (res == undefined) {
                    self.toastr.showError('Unable to save tenant configurations.');
                } else {
                    self.toastr.showSuccess('Changes saved successfully.');
                }
                self.loader = false;
                self.mainPage = true;
                self.isEdit = false;
                self.loadTenantConfigs();
            });
        }
    }

    onResetDefaults() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            let url = BiUrls.TENANT_CONFIG + '/' + self.resetDefaultsUrl;
            this.tenantConfigService.onStartUp(url).then((res) => {
                if (res == undefined) {
                    self.toastr.showError('No Tenant Configurations to load');
                } else {
                    self.toastr.showSuccess('Default configurations restored successfully');
                }
                self.tntConfData = res;
                self.setConfigList();
                self.loader = false;
                self.mainPage = true;
                self.isEdit = false;
                resolve('completed');
            }, (error) => {
                if (error.status == 204) {
                    self.toastr.showError('Cannot load the tenant configurations');
                }
            });
        });
    }

    validateDay(event, ind) {
        let self = this;
        let value = event.target.value != '' ? +event.target.value : 1;
        if (value <= 0 || value > 31) {
            this.tenantConfigList[ind].value = 1;
            event.target.value = 1;
            self.xErrorMsg = 'Date should be from 1 to 31.';
        } else {
            self.xErrorMsg = '';
            this.tenantConfigList[ind].value = value;
        }
    }

    validateNumber(event, ind) {
        let self = this;
        let value = event.target.value != '' ? +event.target.value : 1;
        if (value <= 0) {
            this.tenantConfigList[ind].value = 1;
            event.target.value = 1;
            self.xErrorMsg = '';
        } else {
            self.xErrorMsg = '';
            this.tenantConfigList[ind].value = value;
        }
    }

    validateMonth(event, ind) {
        let self = this;
        let value = event.target.value != '' ? +event.target.value : 1;
        if (value <= 0 || value > 12) {
            this.tenantConfigList[ind].value = 1;
            event.target.value = 1;
            self.xErrorMsg1 = 'Month should be from 1 to 12.';
        } else {
            self.xErrorMsg1 = '';
            this.tenantConfigList[ind].value = value;
        }
    }

    validator() {
        let self = this;
        let flag = false;
        let nameList: any = [];
        for (let conf of self.tenantConfigList) {
            if (conf.value === '') {
                flag = true;
                return conf.displayName + ' field cannot be empty.';
            } else {

            }
        }
        for (let conf of self.customScaleList) {
            if (conf.displayName === '') {
                flag = true;
                return 'Scale display name cannot be empty.';
            } else if (conf.value.value === '') {
                flag = true;
                return conf.displayName + ' field cannot be empty.';
            } else if (conf.value.code === '') {
                flag = true;
                return conf.displayName + ' field cannot be empty.';
            } else if (nameList.includes(conf.displayName.trim())) {
                flag = true;
                return ' Display name cannot be same.';
            } else {
                nameList.push(conf.displayName);

            }
        }

        for (let indicator of self.tntConfData.measureStatusIndicatorData) {
            if (indicator.name === '') {
                flag = true;
                return 'Indicator scale field cannot be empty.';
            } else if (indicator.value === '') {
                flag = true;
                return indicator.name + ' value field cannot be empty.';
            } else {

            }
        }

        for (let colorpalette of self.colorPaletevalue) {
            if (colorpalette.startcolor === '') {
                flag = true;
                return 'start color value field cannot be empty.';
            } 
            else if (colorpalette.endcolor === '') {
                flag = true;
                return 'end color value field cannot be empty.';
            } 
            else {

            }
        }

        

        if (flag == false) {
            return '';
        }
    }

    onBack() {
        let self = this;
        self.loadTenantConfigs();
        self.mainPage = true;
        self.isEdit = false;
        //self.tntConfData = null;
    }

    setScaleKey() {
        let self = this;
        self.customScaleList.forEach(scale => {
            let key = scale.displayName.toUpperCase();
            if (scale.hasOwnProperty('new')) {
                if (key.match(/\s/g)) {
                    key = key.replace(/\s/g, '_');
                }
                key = 'NF_' + key;
                scale.key = key;
                delete scale.new;
            } else {
                key = 'NF_' + key;
                scale.key = key
            }
            scale.value = JSON.stringify(scale.value);
        });
    }

    onSyncDash() {
        let self = this;
        self.loader = true;
        self.tenantConfigService.syncCacheConfig(BiUrls.SYNC_CURRENT_TENANT_PAGE_CACHE).then((res) => {
            if (res.success) {
                self.toastr.showSuccess('Dashboard Cache Synced');
            } else {
                self.toastr.showError('Failed to Sync Cache');
            }
            self.loader = false;
        });
    }

    onFlushDash() {
        let self = this;
        self.loader = true;
        self.tenantConfigService.flushCacheConfig(BiUrls.FLUSH_CURRENT_TENANT_PAGE_CACHE).then((res) => {
            if (res.success) {
                self.toastr.showSuccess('Dashboard Cache Flushed');
            } else {
                self.toastr.showError('Failed to Flush Cache');
            }
            self.loader = false;
        });
    }

    onSyncData() {
        let self = this;
        self.loader = true;
        self.tenantConfigService.syncCacheConfig(BiUrls.SYNC_CURRENT_TENANT_DATA_VS).then((res) => {
            if (res.success) {
                self.toastr.showSuccess('Data Version Cache Synced');
            } else {
                self.toastr.showError('Failed to Sync Cache');
            }
            self.loader = false;
        });
    }

    onSyncCube() {
        let self = this;
        self.loader = true;
        self.tenantConfigService.syncCacheConfig(BiUrls.SYNC_CURRENT_TENANT_CUBE_META).then((res) => {
            if (res.success) {
                self.toastr.showSuccess('Cube Meta Cache Synced');
            } else {
                self.toastr.showError('Failed to Sync Cache');
            }
            self.loader = false;
        });
    }

    getWeekName(day) {
        return day[0].toUpperCase() + day.slice(1);
    }

    changeWeekStartDay(event, config) {
        config.value = event.target.value;
    }

    reBuildDashboardSnaphot() {
        let self = this;
        self.loader = true;
        self.tenantConfigService.reBuildDashboardSnaphot(BiUrls.REBUILD_DASH_SNAPSHOT).then((res) => {
            if (res.success) {
                self.toastr.showSuccess('Dashboard Snapshot Rebuilded Successfully');
            } else {
                self.toastr.showError('Dashboard Snapshot Rebuilded Failed');
            }
            self.loader = false;
        });
    }

    setExpiry(event) {
        if (this.dashboardExpiry) {
            this.dashboardExpiry.value = event.target.value;
        } else {
            this.dashboardExpiry = {
                displayName: "Page Snapshot Expiry",
                key: "PAGE_SNAPSHOT_EXPIRY",
                type: null,
                value: event.target.value
            };
        }
    }

    getValueFor() {
        if (this.dashboardExpiry) {
            return this.dashboardExpiry.value != undefined && this.dashboardExpiry.value != '' ? this.dashboardExpiry.value : 30;
        } else {
            return 30;
        }
    }

    addPageConfig() {
        if (this.dashboardExpiry) {
            let check: boolean = false;
            this.tenantConfigList.forEach(config => {
                if (config.key == 'PAGE_SNAPSHOT_EXPIRY') {
                    check = true;
                    config = {};
                    config = this.dashboardExpiry;
                }
            });
            if (!check) {
                this.tenantConfigList.push(this.dashboardExpiry);
            }
        }
    }

    validateDuration(event) {
        if (event.charCode > 31 && (event.charCode < 48 || event.charCode > 57)) {
            return false;
        }
        if (event.target.value.length >= 3) {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/tenantConfiguration.component.ts